import graphqlClient from '~/graphql/graphqlClient';
import {
  MutationInitSteamPurchaseArgs,
  SteamInitResult,
} from 'dt-common/generated/graphql-types';

const mutation = `
mutation InitSteamPurchase($playerId: String!, $purchaseSelectionId: String!, $platform: String!, $steamId64: String!, $description: String!) {
  initSteamPurchase(playerId: $playerId, purchaseSelectionId: $purchaseSelectionId, platform: $platform, steamId64: $steamId64, description: $description) {
    steamurl
    pdAmount
    orderid
    transid
  }
}
`;

export default async function mutationInitSteamPurchase(args: MutationInitSteamPurchaseArgs) {
  return await graphqlClient.request<SteamInitResult>('initSteamPurchase', mutation, args);
}
